import { useEffect } from "react";

export const useScrollToError = (errors: any) => {
    useEffect(() => {
        if (Object.keys(errors)?.length > 0) {
            const container = document.querySelector(`div.Mui-error`);
            const inputs = container?.getElementsByTagName("input");
            if (!!inputs && inputs.length > 0) {
                const input = inputs[0];
                input?.scrollIntoView({ behavior: "auto", block: "center" });
                input?.focus();
            }
        }
    }, [errors]);
};
